import { yup } from '@framework/validation';
import { CiComputedStringGear } from '../../../../../ui/icons-custom/IconsCustom';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getDynamicWidgetReference } from '../../../../expressions/references/builder/getDynamicWidgetReference';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema';
import { CommonComputedWidgetConfigComponent } from '../CommonComputedWidgetConfigComponent';
import { CommonComputedWidgetPreview } from '../CommonComputedWidgetPreview';
import { IComputedStringWidget } from '../IComputedWidget';
import { ComputedStringConfigSchema } from './ComputedStringConfigSchema';
import { ComputedStringWidgetComponent } from './ComputedStringWidgetComponent';
import { setComputeStringTransform } from './setComputedStringTransform';

export const ComputedStringWidgetType: IWidgetType<IComputedStringWidget> = {
  type: WidgetType.ComputedString,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  hasValue: true,
  getReference: getDynamicWidgetReference(Datatype.String),
  createFormSchema: ({ widget, parentScope }) => {
    return createCommonFormSchema(
      setComputeStringTransform(
        widget,
        parentScope,
        yup.string().notRequired(),
      ),
      widget,
    );
  },
  name: 'Testo Calcolato',
  icon: <CiComputedStringGear />,
  rules: [],
  formComponent: ComputedStringWidgetComponent,
  configComponent: CommonComputedWidgetConfigComponent,
  configValidator: ComputedStringConfigSchema,
  previewComponent: CommonComputedWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
  }),
  alwaysEnabled: true,
};
